"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logEvent = void 0;
const base_1 = require("./base");
const const_1 = require("./const");
const logEvent = (commonLogParams, additionalParams) => __awaiter(void 0, void 0, void 0, function* () {
    return (0, base_1.post)(`${const_1.BASE_PATH}/user-events`, [
        Object.assign(Object.assign({}, commonLogParams), { extraData: additionalParams }),
    ], true);
});
exports.logEvent = logEvent;
